// @flow
import React from 'react'
import { ClickAwayListener } from '@material-ui/core'
import { find, map } from 'lodash/collection'
import i18n from 'i18next'
import ArrowIcon from '../../icons/ArrowIcon'
import {
  Container,
  DropDown,
  Select,
  UnorderedList,
  ListItem,
  PlaceHolder,
  ListItemMobile
} from './styles'

const COLOR_GRAY_LIGHT = '#7d7d7d'
const COLOR_BLACK = '#000000'

type Props = {
  availableLanguages: any,
  changeLanguage: any,
  color?: string,
  isAtMobileView?: boolean,
  isAuthenticated: boolean,
  language: any,
  navigateTo: Function,
  multiLanguagesPaths: Object,
  toggleDrawer?: any
}

type State = { isSelectorOpened: boolean }

export class LanguageSelector extends React.Component<Props, State> {
  state = { isSelectorOpened: false }

  toggleLanguageSelector = () => {
    this.setState({ isSelectorOpened: !this.state.isSelectorOpened })
  }

  handleClickAway = () => {
    this.state.isSelectorOpened &&
      this.setState({
        isSelectorOpened: false
      })
  }

  onChangeLanguage = (language: string) => {
    const { multiLanguagesPaths } = this.props
    i18n.changeLanguage(language, err => {
      if (err) throw new Error()

      this.props.changeLanguage(language, this.props.isAuthenticated)

      this.props.navigateTo(
        multiLanguagesPaths[i18n.language] + window.location.search
      )
    })
  }

  render () {
    if (this.props.isAtMobileView) {
      return map(
        this.props.availableLanguages,
        (language: Object, index: number) => (
          <ListItemMobile
            key={language.code}
            color={
              language.code === this.props.language
                ? COLOR_BLACK
                : COLOR_GRAY_LIGHT
            }
            onClick={() => {
              this.onChangeLanguage(language.code)
              this.props.toggleDrawer && this.props.toggleDrawer()
            }}
          >
            {language.literal}
          </ListItemMobile>
        )
      )
    }

    return (
      <ClickAwayListener onClickAway={this.handleClickAway}>
        <Container>
          <DropDown>
            <Select
              color={this.props.color}
              onClick={this.toggleLanguageSelector}
            >
              <PlaceHolder color={this.props.color}>
                {
                  find(
                    this.props.availableLanguages,
                    (language: Object) => language.code === this.props.language
                  ).literal
                }
              </PlaceHolder>
              <ArrowIcon
                active={this.state.isSelectorOpened}
                color={this.props.color}
              />
            </Select>
            <UnorderedList
              isSelectorOpened={this.state.isSelectorOpened}
              color={this.props.color}
            >
              {map(
                this.props.availableLanguages,
                (language: Object, index: number) => (
                  <ListItem
                    key={index}
                    color={this.props.color}
                    onClick={() => {
                      this.onChangeLanguage(language.code)
                      this.toggleLanguageSelector()
                    }}
                  >
                    {language.literal}
                  </ListItem>
                )
              )}
            </UnorderedList>
          </DropDown>
        </Container>
      </ClickAwayListener>
    )
  }
}

export default LanguageSelector
